import React from 'react'
import cx from 'classnames'

import Box from 'components/layout/Box/Box'
import Text from 'components/typography/Text/Text'

import s from './Tabs.scss'

// tabs: string[] | { title: string; value: string }[]
// selected: string | { title: string; value: string }
const Tabs = ({ tabs, selected, color = 'brand', underlineOnly = false, onSelect }) => (
  <div className={s.tabs}>
    {
      tabs.map((tabItem, index) => {
        const { title, value } = typeof tabItem === 'object' ? tabItem : { title: tabItem, value: tabItem }

        const isSelected = typeof tabItem === 'object' ? selected.value === value : tabs.indexOf(tabItem) === selected

        return (
          <Box
            key={index}
            className={cx(s.text, s.tab)}
            pl={index ? 16 : null}
            onClick={() => onSelect(index, tabs[index])}
          >
            <Text
              className={cx({
                [s.underline]: isSelected,
              })}
              message={title}
              color={color}
              size="16-19"
              weight={isSelected && !underlineOnly ? 'semibold' : null}
            />
          </Box>
        )
      })
    }
  </div>
)


export default Tabs
